import { Dispatch } from 'redux'
import { ws } from 'shared/store/ws'
import endpoints from 'shared/store/endpoints'
import type { ActionsNetwork } from 'shared/store/actions'
import type { SatisfactionForm } from 'shared/types'

type ActionSendFormSuccess = {
    type: 'SATISFACTION_SEND_FORM_SUCCESS'
}

type ActionSendFormError = {
    type: 'SATISFACTION_SEND_FORM_ERROR',
    error: any
}

type ActionResetSatisfactionFormSuccess = {
    type: 'SATISFACTION_RESET_SEND_FORM_SUCCESS'
}

const actionSendFormSuccess = (): ActionSendFormSuccess => ({
    type: 'SATISFACTION_SEND_FORM_SUCCESS'
})

const actionSendFormError = (error: any): ActionSendFormError => ({
    type: 'SATISFACTION_SEND_FORM_ERROR',
    error
})

const sendSatisfactionForm = (form: SatisfactionForm) => {
    return async (dispatch: Dispatch<any>) => {
        try {
            await ws.post(endpoints.satisfaction, form)
            dispatch(actionSendFormSuccess())
        } catch (error) {
            console.error('Error sending satisfaction form :', error)
            dispatch(actionSendFormError(error))
        }
    }
}

const resetSatisfactionFormSuccess = (): ActionResetSatisfactionFormSuccess => ({
    type: 'SATISFACTION_RESET_SEND_FORM_SUCCESS'
})

export { sendSatisfactionForm, resetSatisfactionFormSuccess }

export type Action =
    | ActionSendFormSuccess
    | ActionSendFormError
    | ActionResetSatisfactionFormSuccess
    | ActionsNetwork
